import api from "./api.js";

export default class MemberApi {
  static async getList(data) {
    return await api.get(`api/member`, data);
  }

  static async getDetail(id) {
    return await api.get(`api/member/${id}`);
  }

  static async createGroup(data) {
    return await api.patch(`api/member-group/normal`, data);
  }

  static async memberShipLevel(data) {
    return await api.patch(`api/member/membership/level`, data);
  }

  static async pointSetting(data) {
    return await api.patch(`api/member/point`, data);
  }

  static async writableSetting(data) {
    return await api.patch(`api/member/writable/category`, data);
  }

  static async alarmSend(data) {
    return await api.post(`api/member-alarm`, data);
  }

  static async smsSend(data) {
    return await api.post(`api/member-sms-alarm`, data);
  }

  static async memberOpenMerch(data) {
    return await api.patch(`api/member/open/merch`, data);
  }

  static async memberCoupon(data) {
    return await api.patch(`api/member/coupon`, data);
  }

  //운영진
  static async managerInvite(data) {
    return await api.post(`api/member/invite`, data);
  }

  static async managerDelete(data) {
    return await api.patch(`api/member/admin`, data);
  }

  static async adminCreateGroup(data) {
    return await api.patch(`api/member-group/admin`, data);
  }

  static async adminInviteDelete(data) {
    return await api.patch(`api/member/history/invite`, data);
  }

  static async adminInviteCancel(data) {
    return await api.patch(`api/member/cancel/invite`, data);
  }

  //탈퇴 회원
  static async retiredMemberList(data) {
    return await api.get(`api/retired-member`, data);
  }

  static async retiredMemberDel(data) {
    return await api.del(`api/retired-member`, data);
  }

  static async retiredMemberDetail(id) {
    return await api.get(`api/retired-member/${id}`);
  }
}
